import script from "./newFirstRecharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./newFirstRecharge.vue?vue&type=script&setup=true&lang=ts"

import "./newFirstRecharge.vue?vue&type=style&index=0&id=38d59d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d59d24"]])

export default __exports__